import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Button } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';

import Logo from '../../../Assets/Images/MotiLogo2.png';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';

function ElevationScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default function LPAppBar(props) {
  return (
    <React.Fragment>
      <CssBaseline />
      <ElevationScroll {...props}>
        <AppBar elevation="0">
          <Toolbar>
            <Gene20Box
              // justifyContent="right"
              align="right"
              sx={{
                alignItems: 'center',
                display: 'flex',
                padding: 0,
                margin: 0,
                width: '100%',
              }}
            >
              <Gene20Box
                component="img"
                src={Logo}
                sx={{ width: { xs: '40vw', sm: '20vw' } }}
                height="5vh"
              />
            </Gene20Box>
            <Button variant="contained">login</Button>
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      <Toolbar />
    </React.Fragment>
  );
}
